import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const VirtualConnectionDownstreamDatasourcesQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamDatasourcesQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset:
  Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragment
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
